import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "./SearchSpanGame.css";

const SearchSpanGame = () => {

  const navigate = useNavigate();
  useEffect(() => {
  window.scrollTo({
    top: 0,
    behavior: "smooth"
  });
}, []);

  const [numbers, setNumbers] = useState([]);
  const [currentTarget, setCurrentTarget] = useState(1);
  const [startTime, setStartTime] = useState(null);
  const [time, setTime] = useState(0);
  const [errors, setErrors] = useState(0);
  const [score, setScore] = useState(0);
  const [started, setStarted] = useState(false);
  const [countdown, setCountdown] = useState(null);
  const [page, setPage] = useState("game");
  
  const [leaderboard, setLeaderboard] = useState([]);
  const [userRank, setUserRank] = useState(null);

  // generate numbers
  useEffect(() => {

    const arr = Array.from({ length: 50 }, (_, i) => i + 1);
    const shuffled = arr.sort(() => Math.random() - 0.5);
    setNumbers(shuffled);

    

  }, []);

  // timer
 useEffect(() => {
  if (page !== "game" || !started || !startTime) return;

  const interval = setInterval(() => {
    const now = performance.now();
    const elapsed = (now - startTime) / 1000;

    setTime(elapsed.toFixed(2));

    if (elapsed >= 60) {
      finishGame(currentTarget - 1);
    }

  }, 100);

  return () => clearInterval(interval);

}, [startTime, page, currentTarget, started]);

// 🔥 add score here also
const handleStart = () => {
  let count = 3;
  setCountdown(count);

  const interval = setInterval(() => {
    count--;

    if (count > 0) {
      setCountdown(count);
    } else {
      clearInterval(interval);
      setCountdown("GO!");

      setTimeout(() => {
        setCountdown(null);

        // 🔥 START TIMER HERE
        setStartTime(performance.now());

        setStarted(true); // enable game
      }, 500);
    }

  }, 1000);
};
 const handleClick = (num) => {

  if (!started) return; // ❌ block before start

  if (page !== "game") return;

  if (num === currentTarget) {

    const newScore = currentTarget;
    setScore(newScore);

    if (currentTarget === 50) {
      finishGame(newScore);
    } else {
      setCurrentTarget(prev => prev + 1);
    }

  }
};
  // ================= LEADERBOARD FUNCTION =================
const fetchLeaderboard = async () => {
  try {
    const email = localStorage.getItem("rg_email");

    const res = await axios.get(`/searchspanleaderboard?email=${email}`);

    setLeaderboard(res.data.leaderboard || []);
    setUserRank(res.data.userRank);

  } catch (e) {
    console.log(e);
  }
};

// ================= INITIAL LOAD =================
useEffect(() => {
  fetchLeaderboard(); // ✅ only one call
}, []);

// ================= FINISH GAME =================
const finishGame = async (finalScore = score) => {

  setPage("result");

  const email = localStorage.getItem("rg_email");

  try {

    await axios.post("/save-search-span", {
      email,
      finalNumber: finalScore
    });

    // 🔥 VERY IMPORTANT → refresh leaderboard after save
    await fetchLeaderboard();

  } catch (e) {
    console.log(e);
  }

};

  const handleTryAgain = () => {

    window.location.reload();

  };

  const handleExit = () => {

    navigate("/search-span");

  };

  return (
    <div className="search-span-container">

      {page === "game" && (

        <>
          {!started && !countdown && (
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <button className="start-btn" onClick={handleStart}>
              Start
            </button>
          </div>
        )}

        {/* ⏳ Countdown */}
        {countdown && (
          <div className="countdown">{countdown}</div>
        )}
          <div className="target-box">
            Find Number: <span>{currentTarget}</span>
          </div>

          <div className="timer">
            Time Left: {Math.max(0, (60 - time)).toFixed(2)}s
          </div>

          <div className="grid">

            {numbers.map((num, i) => (

              <div
                key={i}
                className={`cell ${num === currentTarget ? "target-cell" : ""}`}
                onClick={() => handleClick(num)}
              >
                {num}
              </div>

            ))}

          </div>

          <div className="errors">Errors: {errors}</div>

        </>

      )}

      {page === "result" && (

        <div className="result-big-container">

          {/* LEADERBOARD */}

          <div className="leaderboard-box">

            <h3>Leaderboard</h3>

            <table>

              <thead>
                <tr>
                  <th>Rank</th>
                  <th>Name</th>
                  <th>Final Number</th>
                  <th>Medal</th>
                </tr>
              </thead>

             <tbody>
                {leaderboard.slice(0,5).map((p, i) => {

                  let medal = "";

                  if (i === 0) medal = "🥇";
                  else if (i === 1) medal = "🥈";
                  else if (i === 2) medal = "🥉";

                  return (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{p.name}</td>
                      {<td>{p.score}</td>}
                      <td>{medal}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {userRank && (

              <div className="your-rank-box">
                  Rank: {userRank.rank} <br/>
                  Final Number: {score} <br/> {/* 🔥 FIX */}
                  Percentile: {userRank.percentile}%
                </div>

            )}

          </div>

          {/* USER RESULT */}

          <div className="results-box">

            <h2>Your Result</h2>

            <p>Time: {time}s</p>

            <p>Final Number: {score}</p>

            <button onClick={handleTryAgain}>
              Try Again
            </button>

            <button onClick={handleExit}>
              Exit
            </button>

          </div>

        </div>

      )}

    </div>
  );

};

export default SearchSpanGame;